import React from 'react';

export default function CheckMark() {
  return (
    <svg
      width="92"
      height="92"
      viewBox="0 0 92 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M46.0003 0.166992C20.6878 0.166992 0.166992 20.6878 0.166992 46.0003C0.166992 71.3128 20.6878 91.8336 46.0003 91.8336C71.3128 91.8336 91.8336 71.3128 91.8336 46.0003C91.8336 20.6878 71.3128 0.166992 46.0003 0.166992ZM65.867 38.2503C66.2328 37.8322 66.5113 37.3451 66.6861 36.8177C66.8609 36.2903 66.9284 35.7333 66.8848 35.1794C66.8411 34.6256 66.6871 34.086 66.4319 33.5925C66.1766 33.099 65.8252 32.6616 65.3984 32.3059C64.9716 31.9502 64.478 31.6835 63.9466 31.5214C63.4151 31.3593 62.8567 31.3052 62.304 31.3621C61.7513 31.419 61.2156 31.5859 60.7284 31.853C60.2412 32.12 59.8123 32.4818 59.467 32.917L41.5503 54.4128L32.2795 45.1378C31.4936 44.3788 30.4411 43.9589 29.3487 43.9683C28.2562 43.9778 27.2111 44.416 26.4386 45.1886C25.666 45.9611 25.2278 47.0062 25.2183 48.0986C25.2089 49.1911 25.6288 50.2436 26.3878 51.0295L38.8878 63.5295C39.2972 63.9386 39.7874 64.258 40.327 64.4672C40.8667 64.6765 41.4441 64.771 42.0223 64.7447C42.6005 64.7184 43.1669 64.572 43.6854 64.3147C44.2038 64.0574 44.663 63.6949 45.0337 63.2503L65.867 38.2503Z"
        fill="#6DD400"
      />
    </svg>
  );
}
